import PrestamoRepository from '@/services/PrestamoRepository'

export default {
  namespaced: true,
  state: {
    entidad: null,
    listaCronograma: [],
    listaPrestamos: [],
    listaDesembolsos: [],
    listaCuotasPagadas: [],
    listaCuotasPendientes: [],
    tieneResumenPrestamos: false,
    listaResumenPrestamos: []
  },
  mutations: {
    setDetalle(state, prestamo) {
      state.entidad = prestamo.entidad
    },
    setCalendario(state, prestamo) {
      state.listaCronograma = [
        {title: 'Enero', prestamos: []},
        {title: 'Febrero', prestamos: []},
        {title: 'Marzo', prestamos: []},
        {title: 'Abril', prestamos: []},
        {title: 'Mayo', prestamos: []},
        {title: 'Junio', prestamos: []},
        {title: 'Julio', prestamos: []},
        {title: 'Agosto', prestamos: []},
        {title: 'Septiembre', prestamos: []},
        {title: 'Octubre', prestamos: []},
        {title: 'Noviembre', prestamos: []},
        {title: 'Diciembre', prestamos: []},
      ]
      prestamo.map(prestamo => {
        let mesStr = prestamo.fechaVencimiento.split('-')[1]
        let mes = parseInt(mesStr) - 1
        state.listaCronograma[mes].prestamos.push(prestamo)
      })
    },
    setCuotasPendientes(state, prestamos) {
      state.listaPrestamos = []
      for (let prestamo of prestamos) {
        let capitalTotal = 0
        let interesesTotal = 0
        let total = 0
        for (let cuota of prestamo.listaCuotas) {
          capitalTotal = capitalTotal + cuota.importeCapital
          interesesTotal = interesesTotal + cuota.importeInteres
          total = total + cuota.importeTotal
        }
        prestamo.capitalTotal = capitalTotal
        prestamo.interesesTotal = interesesTotal
        prestamo.total = total

        state.listaPrestamos.push(prestamo)
      }
    },
    setResumenPrestamos(state, prestamos) {
      state.listaDesembolsos = []
      state.listaCuotasPagadas = []
      state.listaCuotasPendientes = []
      state.listaResumenPrestamos = prestamos.prestamosEntidadList
      for (let desembolso of prestamos.desembolsoPrestamosList) {
        state.listaDesembolsos.push(desembolso)
      }
      for (let cuotaPagada of prestamos.pagoCuotasPrestamosList) {
        state.listaCuotasPagadas.push(cuotaPagada)
      }
      for (let cuotaPendiente of prestamos.cuotasPendientesPrestamosList) {
        state.listaCuotasPendientes.push(cuotaPendiente)
      }
    },
    setTieneResumenPrestamos(state, tieneResumenPrestamos) {
      state.tieneResumenPrestamos = tieneResumenPrestamos
    },

  },
  actions: {
    async fetchDetalle({commit}, [idPrestamo]) {
      let prestamo = await PrestamoRepository.detalle(idPrestamo)
      commit('setDetalle', prestamo)
    },
    async fetchCalendario({commit}, [anio]) {
      let prestamo = await PrestamoRepository.calendario(anio)
      commit('setCalendario', prestamo)
    },
    async fetchPrestamos({commit}) {
      let prestamos = await PrestamoRepository.cuotasPendientes()
      commit('setCuotasPendientes', prestamos)
    },
    async fetchResumenPrestamos({commit}, [anio]) {
      let prestamos = await PrestamoRepository.resumenPrestamos(anio)
      commit('setResumenPrestamos', prestamos)
    },
    async fetchTieneResumenPrestamos({commit}, [anioDesde, anioHasta]) {
      let tieneResumenPrestamos = await PrestamoRepository.tieneResumenPrestamos(anioDesde, anioHasta)
      commit('setTieneResumenPrestamos', tieneResumenPrestamos)
    },
  }
}
